"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProvider = void 0;
var ClientProvider = (function () {
    function ClientProvider() {
    }
    ClientProvider.prototype.appendQuery = function (requestQuery) {
        var query = Object.keys(requestQuery)
            .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(requestQuery[k]); })
            .join('&');
        return '?' + query;
    };
    return ClientProvider;
}());
exports.ClientProvider = ClientProvider;
//# sourceMappingURL=ClientProvider.js.map